﻿'use strict';

angular.module('ntmApp').factory('StaffSchedulesDragAndDropActions', ['DraggingObject', 'ForecastService', 'FlashService', 'ConfirmationService', 'UnAssignActivityLeeWayValidator', 'ReAssignRescheduleActivityLeeWayValidator', 'ActivitySkillsValidator', 'ActivitiesGroupSkillsValidator', 'Utils', 'WatchDndTargetsService',
function (DraggingObject, ForecastService, FlashService, ConfirmationService, UnAssignActivityLeeWayValidator, ReAssignRescheduleActivityLeeWayValidator, ActivitySkillsValidator, ActivitiesGroupSkillsValidator, Utils, WatchDndTargetsService) {

    function StaffSchedulesDragAndDropActions(staffSchedules, scenarioId) {

        var self = this;

        var StaffSchedule = staffSchedules;
        var UnAssignedActivities = StaffSchedule.UnAssignedActivities;

        var onStartDraggingFromStaffBlockEvent;
        var onDraggedEvent;

        self.DraggableActivityObject = new DraggingObject();
        self.DraggableActivitiesGroupObject = new DraggingObject();

        self.moveActivityDnDTypeDailyPattern = 'MOVE_DAILY_ACTIVITY_OF_DATE_{0}';
        self.moveActivityDnDTypeDefaultPattern = 'MOVE_ACTIVITY_DEFAULT';
        self.moveGroupOfActivitiesPattern = 'MOVE_GROUP';

        self.onStartDraggingFromStaffBlockEvent = function (event) {
            onStartDraggingFromStaffBlockEvent = event;
        };

        self.onDragged = function (event) {
            onDraggedEvent = event;
        };

        self.canBeUnAssignedActivitiesTabTargetApplied = function (tab) {

            if (self.DraggableActivityObject.isDraggingActionActive()) {
                var activity = self.DraggableActivityObject.getDraggingObject();
                return activity.recurrs === 'Daily' ?
                                    moment(activity.dateSchedule).isSame(tab.date, 'day') && activity.personId :
                                    activity.personId || !moment(activity.dateSchedule).isSame(moment(tab.date), 'day');
            }

            if (self.DraggableActivitiesGroupObject.isDraggingActionActive()) {
                var group = self.DraggableActivitiesGroupObject.getDraggingObject();
                return moment(tab.date).isSame(group.date, 'day') && !Utils.IsNull(group.personId);
            }

            return false;
        };

        self.canBeDOWTabTargetApplied = function (tab) {

            if (tab.assignedWithoutAccess || tab.disabled) {
                return false;
            }

            if (self.DraggableActivityObject.isDraggingActionActive() && tab.present) {
                var activity = self.DraggableActivityObject.getDraggingObject();

                if (tab.limitedAccess && !hasAccessToDrag(tab, activity)) {
                    return false;
                }

                return activity.recurrs === 'Daily'?
                                    moment(activity.dateSchedule).diff(moment(tab.date), 'days') === 0 && activity.personId !== tab.blockHeader.personId:
                                    tab.blockHeader.personId !== activity.personId || !moment(tab.date).isSame(moment(activity.dateSchedule), 'day');
            }

            if (self.DraggableActivitiesGroupObject.isDraggingActionActive() && tab.present) {
                var group = self.DraggableActivitiesGroupObject.getDraggingObject();

                if (tab.limitedAccess && !hasGroupAccessToDrag(tab, group)) {
                    return false;
                }
                return moment(tab.date).isSame(group.date, 'day') && tab.blockHeader.personId !== group.personId;
            }

            return false;
        };

        function hasGroupAccessToDrag(tab, group) {
            return group.items.some(function (activity) { return hasAccessToDrag(tab, activity); });
        }

        function hasAccessToDrag(tab, activity) {
            if (StaffSchedule.forecastView === 0) {
                return tab.staffFacilityLimitedAccess && tab.staffFacilityLimitedAccess.some(function (facility) { return facility.id === activity.facilityCode; }) ||
                    tab.staffBrwFacilities && tab.staffBrwFacilities.some(function (facility) { return facility.id === activity.facilityCode; });
            }

            if (StaffSchedule.forecastView === 1) {
                return tab.staffAreaLimitedAccess && tab.staffAreaLimitedAccess.some(function (area) { return area.id === activity.areaId; });
            }
        }

        self.buildDnDTypeByDowActivity = function (activity) {
            return activity.recurrs === 'Daily' ?
                        buildDnDTypeByDate(activity.dateSchedule) :
                        self.moveActivityDnDTypeDefaultPattern;
        };

        function buildDnDTypeByDate(date) {
            return self.moveActivityDnDTypeDailyPattern.format(generateDateCode(date));
        }

        function generateDateCode(date) {
            var current = moment(date);
            var month = current.format('M');
            var day = current.format('D');
            var year = current.format('YYYY');

            return '{0}_{1}_{2}'.format(year, month, day);
        }

        self.startDragActivity = function (activity) {
            self.DraggableActivityObject.setDraggingObject(activity);

            UnAssignedActivities.tabs.forEach(function (tab) {
                tab.dndType = [activity.recurrs === 'Daily' ?
                                    activity.personId ? buildDnDTypeByDate(tab.date) : ['NONE'] :
                                    !activity.personId && moment(tab.date).isSame(moment(activity.dateSchedule), 'day') ? ['NONE'] : self.moveActivityDnDTypeDefaultPattern];
            });

            StaffSchedule.staffBlockHeaders.forEach(function (block) {
                block.availableHours.forEach(function (dow) {

                    if (!dow.present || dow.blockHeader.personId === activity.personId && moment(dow.date).isSame(moment(activity.dateSchedule), 'day')) {
                        dow.dndType = ['NONE'];
                    } else if (activity.recurrs === 'Daily') {
                         if (!activity.personId || activity.personId !== block.personId) {
                             dow.dndType = [buildDnDTypeByDate(dow.date)];
                         } else {
                             dow.dndType = ['NONE'];
                         }
                     } else {
                        dow.dndType = [self.moveActivityDnDTypeDefaultPattern];
                     }
                });
            });

            if (onStartDraggingFromStaffBlockEvent) {
                onStartDraggingFromStaffBlockEvent();
            }
        };

        self.dragActivity = function (activity) {
            
            var droppedTab = findTargetInUnAssignedActivitiesTabs(UnAssignedActivities.tabs);

            if (droppedTab) {
                moveToUnAssigned(droppedTab, activity);
            } else {

                var droppedDOW = findTargetInDOwTabs(StaffSchedule.staffBlockHeaders);

                if (droppedDOW) {
                    moveActivityToOtherDow(activity, droppedDOW.dow, droppedDOW.header, StaffSchedule);
                }
            }

        };

        function moveActivityToOtherDow(activity, dow, header, StaffScheduleObj) {

            var performAction = function () {
                var loading = FlashService.Loading();

                var data = {
                    sourcePersonId: activity.personId ? activity.personId : null,
                    sourceScenarioScheduleId: activity.scheduleId,
                    sourceScheduleDate: activity.dateSchedule,
                    sourcePer: activity.per,
                    sourceDurationUnit: activity.durationUnit,
                    sourceRackId: activity.rackId,
                    targetScheduleDate: dow.date,
                    targetPersonId: header.personId,
                    scenarioId: scenarioId
                };

                ForecastService.DragSchedulеActivity(data).then(function (result) {

                    if (result.success) {
                        FlashService.Success(buildOnMoveActivityToOtherDOWSuccessMessage(activity, dow, header));

                        if (onDraggedEvent) {

                            var args = {
                                dates: [moment(dow.date), moment(activity.dateSchedule)],
                                reloadUnAssignedActivitiesTabs: !activity.personId
                            };

                            onDraggedEvent(activity.personId, activity.personId !== header.personId ? header.personId : null, args);
                        }
                    }

                    loading.dismiss();
                });
            };

            var leeWayValidator = new ReAssignRescheduleActivityLeeWayValidator(activity, dow.date, header);
            var skillsValidator = new ActivitySkillsValidator(activity, dow, header, StaffScheduleObj.allTargetStaffSkills);

            var confirmationsConfiguration = {
                resultAction: performAction,
                confirmations: [
                    { validator: leeWayValidator, data: { title: 'Alert', no: 'Never mind' } },
                    { validator: skillsValidator, data: { title: 'Alert', no: 'Never mind' } }
                ]
            };

            ConfirmationService.ValidationsChain(confirmationsConfiguration);
        }

        function moveToUnAssigned(tab, activity) {

            var performAction = function () {
                var loading = FlashService.Loading();

                var data = {
                    sourcePersonId: activity.personId ? activity.personId : null,
                    sourceScenarioScheduleId: activity.scheduleId,
                    sourceScheduleDate: moment(activity.dateSchedule).format('YYYY-MM-DD'),
                    sourcePer: activity.per,
                    sourceDurationUnit: activity.durationUnit,
                    sourceRackId: activity.rackId,
                    targetScheduleDate: moment(tab.date).format('YYYY-MM-DD'),
                    scenarioId: scenarioId
                };

                ForecastService.DragSchedulеActivity(data).then(function (result) {

                    if (result.success) {
                        FlashService.Success(buildOnUnAssignSuccesMessage(activity, tab));
                        UnAssignedActivities.selectTab(tab);

                        if (onDraggedEvent) {

                            var args = { reloadUnAssignedActivitiesTabs: true };
                            args.dates = moment(activity.dateSchedule).isSame(moment(tab.date), 'day') ? [moment(tab.date)] : [moment(activity.dateSchedule), moment(tab.date)];

                            onDraggedEvent(activity.personId, null, args);
                        }
                    }

                    loading.dismiss();
                });
            };

            var validator = new UnAssignActivityLeeWayValidator(activity, tab.date);

            if (validator.isValid()) {
                performAction();
            } else {
                ConfirmationService.YesNoConfirmation(validator.warningMessage(), null, { title: 'Alert', no: 'Never mind' })
                                   .Yes(performAction)
                                   .Ask();
            }
        }

        function buildOnMoveActivityToOtherDOWSuccessMessage(activity, dow, header) {

            var message = "Activity " + activity.activity + " successfully";

            var reAssignedToOtherPerson = activity.personId !== header.personId;

            if (reAssignedToOtherPerson) {
                message += (activity.personId ? " reassigned to " : " assigned to ") + header.staffName;
            }

            var targetDate = moment(dow.date);
            var sourceDate = moment(activity.dateSchedule);

            if (targetDate.diff(sourceDate, 'days') !== 0) {
                
                if (reAssignedToOtherPerson) {
                    message += " and";
                }

                message += " moved to " + targetDate.format('MM/DD/YYYY');
            }

            message += ".";
            return message;
        }

        function buildOnUnAssignSuccesMessage(activity, tab) {

            var targetDate = moment(tab.date);
            var sourceDate = moment(activity.dateSchedule);

            return targetDate.diff(sourceDate, 'days') === 0 ?
                        'Activity {0} successfully un-assigned.'.format(activity.activity) :
                        'Activity {0} successfully {2} moved to {1}.'.format(activity.activity, targetDate.format('MM/DD/YYYY'), activity.personId ? 'un-assigned and' : '');
        }

        self.endDragActivity = function () {
            if (!WatchDndTargetsService.DKeyPressed) {
                self.DraggableActivityObject.releaseDraggingObject();
            }
            StaffSchedule.defaultDragAndDropTargetsForBlockHeaders();
            UnAssignedActivities.defaultDragAndDropTargetsForTabs();
        };

        function findTargetInUnAssignedActivitiesTabs(tabs) {

            for (var i = 0; i < tabs.length; i++) {
                if (tabs[i].dndTarget && tabs[i].dndTarget.length > 0) {
                    return tabs[i];
                }
            }

            return null;
        }

        function findTargetInDOwTabs(headers) {

            for (var i = 0; i < headers.length; i++) {
                for (var j = 0; j < headers[i].availableHours.length; j++) {

                    if (headers[i].availableHours[j].dndTarget && headers[i].availableHours[j].dndTarget.length > 0) {
                        return {
                            header: headers[i],
                            dow: headers[i].availableHours[j]
                        };
                    }
                }
            }

            return null;
        }

        self.startDragActivitiesGroup = function (group) {
            self.DraggableActivitiesGroupObject.setDraggingObject(group);

            UnAssignedActivities.tabs.forEach(function (tab) {
                
                if (moment(tab.date).isSame(group.date, 'day') && !Utils.IsNull(group.personId)) {
                    tab.dndType = [self.moveGroupOfActivitiesPattern];
                } else {
                    tab.dndType = ['NONE'];
                }
            });


            StaffSchedule.staffBlockHeaders.forEach(function (block) {
                block.availableHours.forEach(function (dow) {
                    if (moment(dow.date).isSame(group.date, 'day') && block.personId !== group.personId) {
                        dow.dndType = [self.moveGroupOfActivitiesPattern];
                    } else {
                        dow.dndType = ['NONE'];
                    }
                });
            });

            if (onStartDraggingFromStaffBlockEvent) {
                onStartDraggingFromStaffBlockEvent();
            }

        };

        self.drag2LevelActivitiesGroup = function (locateGroup) {

            var getSourceItemsAction = function () {
                return locateGroup.items;
            };

            var getGroupNameAction = function () {
                return locateGroup.key;
            };

            dragGroup(locateGroup, getSourceItemsAction, getGroupNameAction);
        };

        self.drag1LevelActivitiesGroup = function (group) {

            var getSourceItemsAction = function () {
                return getItemsOf1stGroup(group);
            };

            var getGroupNameAction = function () {
                return group.key;
            };

            dragGroup(group, getSourceItemsAction, getGroupNameAction);
        };

        self.endDragActivitiesGroup = function () {
            if (!WatchDndTargetsService.DKeyPressed) {
                self.DraggableActivitiesGroupObject.releaseDraggingObject();
            }
            StaffSchedule.defaultDragAndDropTargetsForBlockHeaders();
            UnAssignedActivities.defaultDragAndDropTargetsForTabs();
        };

        function moveGroupToUnAssigned(tab, group, getSourceItemsAction, getGroupNameAction) {

            var loading = FlashService.Loading();

            var data = {
                sourceScheduleIDs: getSourceItemsAction().map(function (activity) {
                    return activity.scheduleId;
                })
            };

            ForecastService.DragSchedulеActivitiesGroup(data).then(function (result) {

                if (result.success) {
                    FlashService.Success('{0} activities successfully un-assigned.'.format(getGroupNameAction()));
                    UnAssignedActivities.selectTab(tab);

                    if (onDraggedEvent) {
                        onDraggedEvent(group.personId, null, {
                            dates: [moment(tab.date)],
                            reloadUnAssignedActivitiesTabs: true
                        });
                    }
                }

                loading.dismiss();
            });
        }

        function moveGroupToOtherDow(group, dow, header, StaffScheduleObj, getSourceItemsAction, getGroupNameAction) {

            var activities = getSourceItemsAction();

            var performAction = function () {
                var loading = FlashService.Loading();

                var data = {
                    targetPersonId: header.personId,
                    sourceScheduleIDs: activities.map(function (activity) {
                        return activity.scheduleId;
                    })
                };

                ForecastService.DragSchedulеActivitiesGroup(data).then(function (result) {

                    if (result.success) {
                        FlashService.Success('{0} activities successfully reassigned to {1}.'.format(getGroupNameAction(), header.staffName));

                        if (onDraggedEvent) {

                            var args = {
                                dates: [moment(dow.date)],
                                reloadUnAssignedActivitiesTabs: !group.personId
                            };

                            onDraggedEvent(group.personId, header.personId, args);
                        }
                    }

                    loading.dismiss();
                });
            };

            var skillsValidator = new ActivitiesGroupSkillsValidator(activities, dow, header, StaffScheduleObj.allTargetStaffSkills, true);

            var confirmationsConfiguration = {
                resultAction: performAction,
                confirmations: [
                    { validator: skillsValidator, data: { title: 'Alert', no: 'Never mind' } }
                ]
            };

            ConfirmationService.ValidationsChain(confirmationsConfiguration);
        }

        function getItemsOf1stGroup(group) {

            if (group.groupsByLocate) {

                var items = [];

                group.groupsByLocate.forEach(function (byLocate) {
                    items = items.concat(byLocate.items);
                });

                return items;
            }

            return group.items;
        }

        function dragGroup(group, getSourceItemsAction, getGroupNameAction) {

            var droppedTab = findTargetInUnAssignedActivitiesTabs(UnAssignedActivities.tabs);

            if (droppedTab) {
                moveGroupToUnAssigned(droppedTab, group, getSourceItemsAction, getGroupNameAction);
            } else {

                var droppedDOW = findTargetInDOwTabs(StaffSchedule.staffBlockHeaders);

                if (droppedDOW) {
                    moveGroupToOtherDow(group, droppedDOW.dow, droppedDOW.header, StaffSchedule, getSourceItemsAction, getGroupNameAction);
                }
            }
        }
    }

    return (StaffSchedulesDragAndDropActions);
}]);